import './style.css';
import { startGame } from './game/startGame';
import { parseAppRoute } from './gallery/routes';
import { startGallery } from './gallery/startGallery';

const mount = document.querySelector<HTMLElement>('#app');
if (!mount) throw new Error('App mount was not found.');

const route = parseAppRoute(window.location.pathname);
document.body.classList.toggle('play-page', route.kind === 'game');
document.body.classList.toggle('gallery-page', route.kind !== 'game');

const dispose = route.kind === 'game'
  ? startGame(mount, {
    screenshotMode: route.screenshotMode,
    screenshotBiome: route.screenshotBiome,
  })
  : startGallery(mount, route);

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js');
  });
}

if (import.meta.hot) import.meta.hot.dispose(dispose);
